import { render, staticRenderFns } from "./AccountPasswordReset.vue?vue&type=template&id=4c5c03e7&"
import script from "./AccountPasswordReset.vue?vue&type=script&lang=js&"
export * from "./AccountPasswordReset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports